import { useEffect } from 'react';

type BeforeInstallPromptEvent = {
  platforms: Array<string>;
  userChoice: Promise<{
    outcome: 'accepted' | 'dismissed';
    platform: string;
  }>;
  prompt(): Promise<void>;
};

declare global {
  interface Window {
    deferredPrompt?: BeforeInstallPromptEvent | null;
  }
}

const handleInstall = (e: Event) => {
  e.preventDefault(); // Prevent the mini-infobar from appearing on mobile
  window.deferredPrompt = e as BeforeInstallPromptEvent & Event;
};

const useInstallPrompt = () => {
  useEffect(() => {
    window.addEventListener('beforeinstallprompt', handleInstall);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleInstall);
    };
  }, []);
};

export default useInstallPrompt;
